module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Ur3AwK/tc-custom/9781781264249.jpg?1705019893886",
      "alt": "This image is the cover for the book 100 Little Christmas Gifts to Make, 100 Little Gifts to Make"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("100 Little Christmas Gifts to Make, 100 Little Gifts to Make\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Crocheting has had a huge surge in popularity in recent years and continues to be a very popular craft, and this book has a very wide appeal both to beginners and more accomplished crocheters. This book represents amazing value, comprising 100 projects from some of our best-selling crochet authors. The book covers a wide variety of themes from beautiful crocheted flowers, beanie hats, Christmas crocheted projects, cute bears, lovely hearts and stylish purses, so there is something for everyone to enjoy. Crochet requires very little in the way of tools and materials, which are widely available from major yarn stores and relatively inexpensive. The techniques used in this book are simple enough for experienced beginners to master, and easy for more seasoned crocheters. Special stitches used are explained in detail, and yarns are described in generic terms, so that readers can use what is available to them, wherever they live. The projects cover a wide variety of themes from Christmas crochet, beanies, hearts, flowers, purses, bears and granny squares. They are simple enough for experienced beginners and will also appeal to seasoned crocheters. The tools and materials are inexpensive and widely available and these charming crocheted items make fabulous gifts for family and friends.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Search Press Studio\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Search Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0